import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface UserDocumentSearchState {
  isModalOpen: boolean;
  isViewerOpen: boolean;
  queryText: string;
  selectedDocumentIds: string[];
  isSearchAll: boolean;
  searchResults: any[];
  currentQueryId: string | null;
  isSearching: boolean;
  statusMessage: string;
}

const initialState: UserDocumentSearchState = {
  isModalOpen: false,
  isViewerOpen: false,
  queryText: '',
  selectedDocumentIds: [],
  isSearchAll: false,
  searchResults: [],
  currentQueryId: null,
  isSearching: false,
  statusMessage: ''
};

const userDocumentSearchSlice = createSlice({
  name: 'userDocumentSearch',
  initialState,
  reducers: {
    openSearchModal: (state, action: PayloadAction<{ documentIds?: string[], isSearchAll?: boolean }>) => {
      state.isModalOpen = true;
      state.selectedDocumentIds = action.payload.documentIds || [];
      state.isSearchAll = action.payload.isSearchAll || false;
      state.isViewerOpen = false;
      state.isSearching = false;
      state.statusMessage = '';
    },
    closeSearchModal: (state) => {
      state.isModalOpen = false;
    },
    startSearching: (state, action: PayloadAction<{ queryId: string }>) => {
      state.isSearching = true;
      state.currentQueryId = action.payload.queryId;
      state.statusMessage = 'Starting smart search...';
    },
    setSearchStatus: (state, action: PayloadAction<string>) => {
      state.statusMessage = action.payload;
    },
    openViewer: (state, action: PayloadAction<{ results: any[], query?: string }>) => {
      state.isViewerOpen = true;
      state.isModalOpen = false; // Close search modal when opening viewer
      state.isSearching = false;
      state.searchResults = action.payload.results;
      if (action.payload.query) {
        state.queryText = action.payload.query;
      }
    },
    closeViewer: (state) => {
      state.isViewerOpen = false;
    },
    setQueryText: (state, action: PayloadAction<string>) => {
      state.queryText = action.payload;
    },
    setSelectedDocumentIds: (state, action: PayloadAction<string[]>) => {
      state.selectedDocumentIds = action.payload;
    }
  }
});

export const {
  openSearchModal,
  closeSearchModal,
  startSearching,
  setSearchStatus,
  openViewer,
  closeViewer,
  setQueryText,
  setSelectedDocumentIds
} = userDocumentSearchSlice.actions;

export default userDocumentSearchSlice.reducer;
